import appLocaleData from 'react-intl/locale-data/da'
import daAppMessages from '../locales/app.da_DK.json'
import daDataMessages from '../locales/data-labels.da_DK.json'

const daLang = {
  messages: {
    ...daAppMessages,
    ...daDataMessages
  },
  locale: 'da-DK',
  data: appLocaleData
}
export default daLang



// WEBPACK FOOTER //
// ./lngProvider/entries/da-DK.js